export enum TaskUrgency {
  // User clicks something, and expects an interactive response.
  Interactive = -2,

  // A modal dialog box will not be dismissed before completion.
  Modal = -1,

  // No urgency has been specified.
  Default = 0,

  // User has started a long running operation that should not block the use of
  // the application.
  LongRunning = 1,

  // Do when there's nothing else important to do.
  Idle = 2
}

export interface TaskPriority {
  urgency: TaskUrgency;
  serial: number;
}
